import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLang from 'element-ui/lib/locale/lang/en'
import 'default-passive-events'
import './assets/icon/iconfont.css'

// mock
// if (process.env.NODE_ENV === "development") {
//   require('../mock/mock.js')
// }


Vue.config.productionTip = false
Vue.use(ElementUI, {
  locale: enLang
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
